import type { MutableRefObject } from "react"
import type { WebViewerInstance } from "@pdftron/webviewer"

// Open/close controls for an Apryse `UI.addPanel` sidebar, paired with the React open-state
// setter that mirrors the panel's visibility. Reads the instance from a ref so the returned
// handlers stay stable across renders.
export const createPanelControls = (
	instanceRef: MutableRefObject<WebViewerInstance | null>,
	dataElement: string,
	setIsOpen: (open: boolean) => void,
) => ({
	open: () => {
		if (instanceRef.current) {
			instanceRef.current.UI.openElements([dataElement])
			setIsOpen(true)
		}
	},
	close: () => {
		if (instanceRef.current) {
			instanceRef.current.UI.closeElements([dataElement])
			setIsOpen(false)
		}
	},
})
